/* PureEthical - carregador das camadas de design.
   A ordem importa: a ultima folha manda.

   PEV quebra a cache do CDN. Estava fixo, e por isso qualquer folha
   alterada continuava a ser servida na versao antiga no mesmo
   endereco - foi o que escondeu semanas de correccoes. Enquanto o
   site estiver a ser trabalhado, a versao roda de hora a hora.
   Quando estabilizar, fixa-se num valor. */
(function () {
  var PEV = 'h' + Math.floor(Date.now() / 3600000);

  function assetUrl(name, flag) {
    var map = window.PE_ASSETS;
    if (map && map[flag]) return map[flag];
    var probe = document.querySelector('link[href*="pe-tabbar.css"]');
    if (!probe) return null;
    var href = probe.getAttribute('href').replace('pe-tabbar.css', name);
    return href.split('?')[0] + '?pev=' + PEV;
  }

  function loadSheet(name, flag) {
    if (document.querySelector('link[data-pe-' + flag + ']')) return;
    var href = assetUrl(name, flag);
    if (!href) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-pe-' + flag, '1');
    document.head.appendChild(link);
  }

  function loadScript(name, flag) {
    if (document.querySelector('script[data-pe-' + flag + ']')) return;
    var src = assetUrl(name, flag);
    if (!src) return;
    var s = document.createElement('script');
    s.src = src; s.defer = true;
    s.setAttribute('data-pe-' + flag, '1');
    document.head.appendChild(s);
  }

  /* ---------------- guardiao de marcas ---------------- */
  var BRAND_SLOTS = ['.nh-pc-brand','.nh-bw-name','.gs-subtitle','.gs-also-like-brand','.cd-item-brand','.qv-brand','#qaVendor','.pe-sa-brand','.brand-card','.pc-brand','.card-brand','.prod-brand','[data-brand]'].join(',');

  var BRANDS = ['TOMMY HILFIGER','CALVIN KLEIN','BOSS','HUGO BOSS','NORTH SAILS','NORWAY 1963','U.S. POLO ASSN.','U.S. GRAND','PEPE JEANS','CAVALLI CLASS','ROBERTO CAVALLI','BIKKEMBERGS','AERONAUTICA MILITARE','ACCADEMIA MILITARE','ALV BY ALVIERO MARTINI','ALVIERO MARTINI','ARMATA DI MARE','AVIREX','TRUSSARDI','DIESEL',"LEVI'S",'RALPH LAUREN','NIKE','JORDAN','ADIDAS','PUMA','FRED PERRY','GANT','SUPERDRY','GEOX','DR.MARTENS','CONVERSE','FILA','KAPPA','DIADORA','ELLESSE','REEBOK','SUPERGA','FURLA','COCCINELLE','MANDARINA DUCK','EASTPAK','PIQUADRO','LOVE MOSCHINO','MOSCHINO','JUST CAVALLI','KARL LAGERFELD','LOTTO','ICEBERG','BLAUER','NAPAPIJRI','LA MARTINA','GUESS','GUESS JEANS','WOOLRICH','DESIGUAL','EMPORIO ARMANI','ARMANI EXCHANGE','VERSACE','MICHAEL KORS','TIMBERLAND','THE NORTH FACE','COLMAR','K-WAY','VALENTINO BAGS','PLEIN SPORT','MARINA YACHTING','MARINA MILITARE','LAURA BIAGIOTTI','TWINSET','FREDDY','RIFLE','CLARKS','GOLA','SERGIO TACCHINI','LUMBERJACK','GIAN MARCO VENTURI','COVERI MOVING','CARRERA','COLUMBIA','NAVIGARE','REFRIGIWEAR','CAFENOIR','BYBLOS','COSTUME NATIONAL','ROMEO GIGLI','BOXEUR DES RUES','BACI&ABBRACCI','ZUELEMENTS','A-STYLE','PHARD','DATCH','MARES','ESERCITO 1659','PURE ETHICAL','PUREETHICAL'];
  var SET = {};
  for (var i = 0; i < BRANDS.length; i++) SET[BRANDS[i]] = 1;

  function protect(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.getAttribute('translate') === 'no') return;
    el.setAttribute('translate', 'no');
    el.classList.add('notranslate');
  }
  function markSlots(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    var els = scope.querySelectorAll(BRAND_SLOTS);
    for (var i = 0; i < els.length; i++) protect(els[i]);
    if (root && root.nodeType === 1 && root.matches && root.matches(BRAND_SLOTS)) protect(root);
  }
  function markByText(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.childElementCount !== 0) return;
    var t = (el.textContent || '').trim().toUpperCase();
    if (!t || t.length > 40) return;
    if (SET[t]) { protect(el); return; }
    for (var i = 0; i < BRANDS.length; i++) if (t.indexOf(BRANDS[i]) === 0) { protect(el); return; }
  }
  function scanText(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    var els = scope.querySelectorAll('a,span,p,h1,h2,h3,h4,h5,li,div,option,button,strong,em,b,td');
    for (var i = 0; i < els.length; i++) markByText(els[i]);
  }
  function brandGuard() {
    markSlots(document); scanText(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var ad = muts[i].addedNodes;
        for (var j = 0; j < ad.length; j++) {
          var n = ad[j];
          if (n.nodeType !== 1) continue;
          markSlots(n); markByText(n);
          if (n.querySelectorAll) scanText(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------------- faixa de garantias ---------------- */
  var ICON = {
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    back:  '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>'
  };
  var ASSURE = {
    en: ['100% authentic, tags attached', '14-day returns'],
    pt: ['100% originais, com etiqueta', 'Devoluções em 14 dias'],
    it: ['100% autentici, con etichetta', 'Resi entro 14 giorni'],
    fr: ['100% authentiques, avec étiquette', 'Retours sous 14 jours'],
    de: ['100% original, mit Etikett', '14 Tage Rückgaberecht'],
    es: ['100% auténticos, con etiqueta', 'Devoluciones en 14 días']
  };
  function assureText() {
    var l = (window._PE_LANG || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return ASSURE[l] || ASSURE.en;
  }
  function assuranceBand() {
    var nh = document.querySelector('.nh');
    if (!nh || nh.querySelector('.pe-assure')) return;
    var hero = nh.querySelector('.nh-hero');
    if (!hero) return;
    var T = assureText();
    var band = document.createElement('div');
    band.className = 'pe-assure';
    band.innerHTML = '<div class="pe-assure-in">' +
      '<span>' + ICON.check + T[0] + '</span>' +
      '<span>' + ICON.back  + T[1] + '</span>' +
      '</div>';
    hero.insertAdjacentElement('afterend', band);
  }

  /* ---------------- barra de compra fixa ---------------- */
  var ATC  = { en: 'Add to bag', pt: 'Adicionar ao cesto', it: 'Aggiungi al carrello', fr: 'Ajouter au panier', de: 'In den Warenkorb', es: 'Añadir a la cesta' };
  var PICK = { en: 'Choose a size', pt: 'Escolher tamanho', it: 'Scegli la taglia', fr: 'Choisir la taille', de: 'Größe wählen', es: 'Elegir talla' };
  var HINT = { en: 'Select your size', pt: 'Escolha o seu tamanho', it: 'Seleziona la taglia', fr: 'Sélectionnez votre taille', de: 'Größe auswählen', es: 'Selecciona tu talla' };

  function stickyAtc() {
    if (!document.body.classList.contains('t-product')) return;
    if (document.getElementById('peStickyAtc')) return;
    var real = document.getElementById('prodAtcBtn');
    if (!real) return;

    var lang = (window._PE_LANG || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var L_ADD = ATC[lang] || ATC.en, L_PICK = PICK[lang] || PICK.en, L_HINT = HINT[lang] || HINT.en;
    var brandEl = document.querySelector('.gs-subtitle') || document.querySelector('.gs-title');

    var bar = document.createElement('div');
    bar.id = 'peStickyAtc';
    bar.innerHTML =
      '<div class="pe-sa-hint"></div>' +
      '<div class="pe-sa-sizes"></div>' +
      '<div class="pe-sa-info"><span class="pe-sa-brand" translate="no"></span><span class="pe-sa-price"></span></div>' +
      '<button type="button" class="pe-sa-btn"></button>';
    document.body.appendChild(bar);

    var brandOut = bar.querySelector('.pe-sa-brand');
    var priceOut = bar.querySelector('.pe-sa-price');
    var sizesOut = bar.querySelector('.pe-sa-sizes');
    var btn = bar.querySelector('.pe-sa-btn');
    bar.querySelector('.pe-sa-hint').textContent = L_HINT;
    brandOut.classList.add('notranslate');
    brandOut.textContent = brandEl ? (brandEl.textContent || '').trim() : '';

    function realSizes() { return Array.prototype.slice.call(document.querySelectorAll('.sz-btn')); }
    function sizeChosen() {
      var all = realSizes();
      if (!all.length) return true;
      var need = {}, have = {};
      all.forEach(function (b) { need[b.dataset.opt] = 1; });
      all.forEach(function (b) { if (b.classList.contains('on')) have[b.dataset.opt] = 1; });
      for (var g in need) if (!have[g]) return false;
      return true;
    }
    function buildSizes() {
      sizesOut.innerHTML = '';
      realSizes().forEach(function (src) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'pe-sa-sz' + (src.classList.contains('on') ? ' on' : '');
        chip.textContent = (src.dataset.val || src.textContent || '').trim();
        if (src.disabled || src.classList.contains('sz-sold-out')) chip.disabled = true;
        chip.addEventListener('click', function () {
          if (chip.disabled) return;
          src.click();
          setTimeout(function () { buildSizes(); sync(); bar.classList.remove('pe-sa-open'); }, 30);
        });
        sizesOut.appendChild(chip);
      });
    }
    function sync() {
      var now = document.querySelector('.gs-price');
      var was = document.querySelector('.gs-price-was');
      priceOut.innerHTML = '';
      if (now) { var a = document.createElement('span'); a.textContent = (now.textContent || '').trim(); priceOut.appendChild(a); }
      if (was && (was.textContent || '').trim()) { var b = document.createElement('span'); b.className = 'pe-sa-was'; b.textContent = (was.textContent || '').trim(); priceOut.appendChild(b); }
      var ready = sizeChosen();
      /* v36 Fase 3AE: cor esgotada - o botao principal ja diz "Esgotado" (theme.js marca-o com
         data-pe-sold-out e usa a traducao products.sold_out). A barra repete o mesmo texto em vez de
         "Adicionar ao cesto"; continua desativada como o botao principal. */
      var rt = (real.textContent || '').trim();
      var so = window.PE_T ? window.PE_T('sold_out', '') : '';
      var soldOut = !!real.disabled && (real.dataset.peSoldOut === '1' || (!!so && rt === so));
      btn.textContent = soldOut ? (so || rt) : (ready ? L_ADD : L_PICK);
      btn.classList.toggle('pe-sa-need', !ready && !soldOut);
      btn.disabled = !!real.disabled;
      if (ready) bar.classList.remove('pe-sa-open');
    }

    buildSizes(); sync();

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      if (!sizeChosen()) { buildSizes(); bar.classList.toggle('pe-sa-open'); return; }
      real.click();
    });

    var row = document.querySelector('.gs-price-row');
    if (row && window.MutationObserver) new MutationObserver(sync).observe(row, { childList: true, characterData: true, subtree: true });
    if (window.MutationObserver) new MutationObserver(sync).observe(real, { attributes: true, childList: true, characterData: true, subtree: true });
    var grid = document.querySelector('.gs-size-grid') || document.querySelector('.gs-size-section');
    if (grid && window.MutationObserver) {
      new MutationObserver(function () { buildSizes(); sync(); })
        .observe(grid, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
    }
    if (!('IntersectionObserver' in window)) { bar.classList.add('on'); return; }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('on', passed);
      if (!passed) bar.classList.remove('pe-sa-open');
    }, { threshold: 0 }).observe(real);
  }

  function init() {
    var isProduct = document.body.classList.contains('t-product');
    loadSheet('pe-collection-fit.css', 'fit');
    loadSheet('pe-natural.css', 'natural');
    loadSheet('pe-uplift.css', 'uplift');
    loadSheet('pe-refine.css', 'refine');
    loadSheet('pe-menu.css', 'menu');
    if (isProduct) loadSheet('pe-product.css', 'product');
    loadSheet('pe-footer.css', 'footer');
    /* camadas novas, em ultimo lugar */
    loadSheet('pe-cart-design.css', 'cartdesign');
    loadSheet('pe-cart-hi.css', 'carthi');
    loadSheet('pe-gutters.css', 'gutters');
    if (isProduct) loadSheet('pe-product-ui.css', 'produi');
    loadSheet('pe-sale.css', 'sale');
    loadSheet('pe-cart-mono.css', 'cartmono');
    loadScript('pe-region.js', 'region');
    loadScript('pe-wishlist-fix.js', 'wlfix');
    loadScript('pe-tweaks.js', 'tweaks');
    if (isProduct) loadScript('pe-price-fix.js', 'pricefix');
    brandGuard();
    assuranceBand();
    stickyAtc();
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { assuranceBand(); stickyAtc(); markSlots(document); scanText(document); }, 60);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
